export default function disablePointerEvents() {
  const inputs = $('input');
  $('[title]').mouseover(function () {
    let currentinput = $(this);
    currentinput.data('title', currentinput.attr('title'));
    currentinput.attr('title', '');
  }).mouseout(function () {
    let currentinput = $(this);
    currentinput.attr('title', currentinput.data('title'));
  });

}
